export default __webpack_public_path__ + "static/media/bv.db29881d.svg";